import { render, staticRenderFns } from "./MalariaAcquireSample.vue?vue&type=template&id=45168714&scoped=true"
import script from "./MalariaAcquireSample.vue?vue&type=script&lang=js"
export * from "./MalariaAcquireSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45168714",
  null
  
)

export default component.exports